import React, { useState } from 'react'

const KlaviyoForm = ({ formId }) => {
  const [height, setHeight] = useState(0)

  const onLoad = (event) => {
    const iframe = event.target
    const div = iframe.contentDocument.querySelector(`.${formId}`)
    const resizeObserver = new ResizeObserver((entries) => {
      setHeight(div.offsetHeight)
    })
    resizeObserver.observe(div)
  }

  return (
    <div className="klaviyo-form">
      <iframe
        style={{
          height: height,
        }}
        onLoad={onLoad}
        title={formId}
        src={`/klaviyo-form.html?${formId}`}
      ></iframe>
    </div>
  )
}

export default KlaviyoForm
